import { render, staticRenderFns } from "./1099taxform.vue?vue&type=template&id=799d0ec4&scoped=true"
import script from "./1099taxform.vue?vue&type=script&lang=js"
export * from "./1099taxform.vue?vue&type=script&lang=js"
import style0 from "./1099taxform.vue?vue&type=style&index=0&id=799d0ec4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d0ec4",
  null
  
)

export default component.exports